import styled from 'styled-components/macro';

import TicketButton from '../Buttons/TicketButton/TicketButton';

export const DropDownContainer = styled.div`
  display: inline-block;
  margin-bottom: 10px;
  margin-right: 10px;
`;

export const ForwardToExpertWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0;
`;

export const Button = styled(TicketButton)`
  margin: 0px 10px 10px 0px;
`;
